module.exports = __webpack_public_path__ + "img/post_sample_twitter.d93cf3ca.png";